import React from "react";
import PrintableAddForm from "@/components/PrintableAddForm";

const ROWS = [
  [
    { label: "Machine name / model", flex: 3 },
    { label: "Category (e.g. 3D printer)", flex: 2 },
  ],
  [
    { label: "Department(s)", flex: 3 },
    { label: "Status (working / broken / idle)", flex: 2 },
  ],
  [
    { label: "Supplier", flex: 3 },
    { label: "Purchase date", flex: 2 },
    { label: "Warranty end", flex: 2 },
  ],
  [
    { label: "Primary technician / service co.", flex: 3 },
    { label: "Service agreement in place?", flex: 2 },
  ],
  [
    { label: "Location on floor", flex: 3 },
    { label: "Estimated value (approx)", flex: 2 },
  ],
];

const MachineryAddPrint = () => (
  <PrintableAddForm
    pageTitle="Add machinery"
    toolbarHint="Hand this out to staff during the machinery walk-through. Any machine found on the floor that isn't already in the app — one form per machine, then give the page back to the manager."
    eyebrow="Podlab · Machinery register"
    scope="Machinery register"
    formTitle="Add-machine sheet"
    rows={ROWS}
    starField={{ label: "Serial number / asset tag" }}
    noteLabel="Notes · condition · attachments · anything odd"
    testid="add-machine-print-page"
  />
);

export default MachineryAddPrint;
